/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

/*
 * Footer used across all the pages
 */

import React, { Suspense, useEffect, useState, useRef, lazy } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import styled from "styled-components";
import "./footerNew.css";
import styles from "./index.module.css";
import axios from "axios";
import parser from "html-react-parser";

const Img = lazy(() => import("../Img2"));

const FooterWrapper = styled.div`
@media (min-width:1380px){
  .container{
  max-width: 100%;
padding: 0 50px;
  }
  .awardsSecondCol.col-md-5.col-sm-12.col-12 {
    flex: 28%;
    max-width: 28%;
}
`;

const CustomFooter = (props) => {
  const ref = useRef();
  const [isIntersecting, setIntersecting] = useState(false);
  const [footerInfoData, setFooterInfoData] = useState();

  useEffect(() => {
    /**
     * The below function is used to fetch the swmc footer data which
     * is stored in master JSON in S3 bucket.
     * @returns JSON Object of the requested file
     */
    const fetchSWMCFooterInfo = async () => {
      try {
        await axios
          .get(process.env.REACT_APP_SWMC_FOOTET_INFO)
          .then((response) => {
            //console.log(response.data);
            setFooterInfoData(response.data);
            const observer = new IntersectionObserver(([entry]) => {
              if (entry.isIntersecting) {
                setIntersecting(entry.isIntersecting);
                observer.disconnect();
              }
            });
            observer.observe(ref.current);
            // Remove the observer as soon as the component is unmounted
            return () => {
              observer.disconnect();
            };
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    };

    fetchSWMCFooterInfo();
  }, []);

  let date = new Date();
  let currentYear = date.getFullYear();
  return (
    <FooterWrapper>
      <div className="disclaimernh">
        For licensed mortgage professionals only; not for consumers. Sun West
        Mortgage Company, Inc. (NMLS 3277) is an Equal Opportunity Employer. The
        company and its affiliates recruit and hire qualified candidates without
        regard to race, religion, sex, sexual orientation, gender, gender
        identity, age, national origin, ancestry, citizenship, Veteran or
        disability status, medical condition, marital status, or any other
        factor prohibited by federal, state, provincial, and municipal laws. For
        licensing information, go to: <a href="https://www.nmlsconsumeraccess.org/TuringTestPage.aspx?ReturnUrl=/EntityDetails.aspx/company/3277" target="_blank">www.nmlsconsumeraccess.org</a>.
      </div>
      <footer>
        {footerInfoData ? (
          <>
            <Container>
              <Row className="top-row">
                <Col
                  xl={7}
                  lg={7}
                  md={12}
                  sm={12}
                  xs={12}
                  className={styles.desctypo}
                >
                  <div className={styles.logosize}>
                    <Suspense fallback={<div>Loading...</div>}>
                      <Img>
                        <a
                          href={footerInfoData.sunWestLogoInfo.url}
                          target="_blank"
                          rel="noopener"
                          title={footerInfoData.sunWestLogoInfo.title}
                        >
                          <img
                            src={footerInfoData.sunWestLogoInfo.imgPath}
                            alt={footerInfoData.sunWestLogoInfo.alt}
                            className={styles.footer_logo}
                            loading="lazy"
                          />
                        </a>
                      </Img>
                    </Suspense>
                  </div>
                  <br />
                  <div className={styles.footer_desc_text}>
                    <b>{parser(footerInfoData.disclaimer)}</b>
                  </div>
                  {/* <div style={{ marginTop: "-10px" }} className="disclaimer2">
                    {parser(footerInfoData.nyStateWithSunWestMortgageDisclaimer)}
                  </div> */}
                </Col>
                <Col
                  md={{ span: 12, offset: 0 }}
                  lg={4}
                  sm={12}
                  xs={12}
                  className="contactus"
                >
                  <div className="contact_block">
                    <h4>{parser(footerInfoData.contactUs.heading)}</h4>

                    <div className="ul_footer">
                      <div style={{ display: "flex" }}>
                        <Suspense fallback={<div>Loading...</div>}>
                          <Img>
                            <img
                              style={{
                                width: "20px",
                                height: "20px",
                                marginTop: "4px",
                              }}
                              src={footerInfoData.contactUs.address.imgPath}
                              alt={footerInfoData.contactUs.address.alt}
                            />
                          </Img>
                        </Suspense>
                        <p>
                          <a
                            style={{ color: "#fff" }}
                            target="_blank"
                            href={
                              footerInfoData.contactUs.address.googleMapsUrl
                            }
                            rel="noopener"
                          >
                            {footerInfoData.contactUs.address.fullAddress}
                          </a>
                        </p>
                      </div>
                      <div className="contactOptions">
                        <div style={{ display: "flex" }}>
                          <Suspense fallback={<div>Loading...</div>}>
                            <Img>
                              <img
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  marginTop: "4px",
                                }}
                                src={footerInfoData.contactUs.phone.imgPath}
                                alt={footerInfoData.contactUs.phone.alt}
                              />
                            </Img>
                          </Suspense>
                          <p>
                            <a
                              href={"tel:+15166047454"}
                              style={{ color: "#fff" }}
                            >
                              (516) 604-7454
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="social_footer">
                      <div className={styles.social_footer}>
                        {footerInfoData.connectWithUs.socialMediaLinks.map(
                          (socialMediaLinksData, i) => (
                            <a
                              key={i}
                              href={socialMediaLinksData.url}
                              target="_blank"
                              rel="noopener"
                              title={socialMediaLinksData.title}
                            >
                              <Suspense fallback={<div>Loading...</div>}>
                                <Img>
                                  <img
                                    className={styles.marginImg}
                                    style={{
                                      width: "35px",
                                      height: "35px",
                                      margin: "10px",
                                    }}
                                    src={socialMediaLinksData.imgPath}
                                    alt={socialMediaLinksData.alt}
                                  />
                                </Img>
                              </Suspense>
                            </a>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <hr style={{ borderTop: "1px solid #fff" }} />
              <Row className="awardrow">
                <Col md={12}>
                  <Row style={{ justifyContent: "center" }}>
                    <Col xl={7} md={12}>
                      <Row style={{ justifyContent: "center" }}>
                        <Col
                          md={3}
                          sm={4}
                          xs={4}
                          lg={3}
                          xl={3}
                          className="topIconCol"
                        >
                          <Suspense fallback={<div>Loading...</div>}>
                            <Img>
                              <a
                                href="https://sunwestmortgage.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <img
                                  src={
                                    footerInfoData.companyAwards
                                      .mortgageExecutiveTop50.imgPath
                                  }
                                  className={styles.top50}
                                  alt={
                                    footerInfoData.companyAwards
                                      .mortgageExecutiveTop50.alt
                                  }
                                  title={
                                    footerInfoData.companyAwards
                                      .mortgageExecutiveTop50.title
                                  }
                                  style={{
                                    width: "100px",
                                    height: "170px",
                                    maxWidth: "130px",
                                  }}
                                  loading="lazy"
                                />
                              </a>
                            </Img>
                          </Suspense>
                        </Col>

                        <Col
                          xl={3}
                          lg={3}
                          md={3}
                          sm={8}
                          xs={6}
                          className="bbbDiv ps-0"
                        >
                          <Row style={{ flexDirection: "column" }}>
                            <Col md={6}>
                              <Suspense fallback={<div>Loading...</div>}>
                                <Img>
                                  <a
                                    href={
                                      footerInfoData.companyAwards.bbbRating.url
                                    }
                                    target="_blank"
                                    rel="noopener"
                                    title={
                                      footerInfoData.companyAwards.bbbRating
                                        .title
                                    }
                                  >
                                    <img
                                      src={
                                        footerInfoData.companyAwards.bbbRating
                                          .imgPath
                                      }
                                      className="bbb"
                                      style={{
                                        width: "150px",
                                        marginBottom: "20px",
                                        maxWidth: "150px",
                                        marginLeft: "-10px",
                                      }}
                                      alt={
                                        footerInfoData.companyAwards.bbbRating
                                          .alt
                                      }
                                      loading="lazy"
                                    />
                                  </a>
                                </Img>
                              </Suspense>
                            </Col>

                            <Col md={6}>
                              <Suspense fallback={<div>Loading...</div>}>
                                <Img>
                                  <a
                                    href={
                                      footerInfoData.companyAwards.bcaRating.url
                                    }
                                    target="_blank"
                                    rel="noopener"
                                    title={
                                      footerInfoData.companyAwards.bcaRating
                                        .title
                                    }
                                  >
                                    <img
                                      src={
                                        footerInfoData.companyAwards.bcaRating
                                          .imgPath
                                      }
                                      className={styles.alliance}
                                      alt={
                                        footerInfoData.companyAwards.bcaRating
                                          .alt
                                      }
                                      style={{
                                        width: "130px",
                                        marginBottom: "20px",
                                        maxWidth: "130px",
                                      }}
                                      loading="lazy"
                                    />
                                  </a>
                                </Img>
                              </Suspense>
                            </Col>
                          </Row>
                        </Col>

                        <Col md={3} sm={6} lg={3} xl={3} className="ehoBirdeye">
                          <Suspense fallback={<div>Loading...</div>}>
                            <Img>
                              <img
                                src={
                                  footerInfoData.companyAwards
                                    .equalHousingOpportunity.imgPath
                                }
                                alt={
                                  footerInfoData.companyAwards
                                    .equalHousingOpportunity.alt
                                }
                                title={
                                  footerInfoData.companyAwards
                                    .equalHousingOpportunity.title
                                }
                                className={styles.homicon + " " + "img-fluid"}
                                loading="lazy"
                                width={"100%"}
                                height={"100%"}
                              />
                            </Img>
                          </Suspense>
                          <div className="birdeyeContainer">
                            {/* {isIntersecting ? ( */}
                            <Suspense fallback={<div>Loading...</div>}>
                              <Img>
                                <a
                                  href={
                                    footerInfoData.companyAwards.birdEyeReviews
                                      .url
                                  }
                                  target="_blank"
                                  rel="noopener"
                                >
                                  <iframe
                                    name="bfiframe"
                                    title="birdeye"
                                    className={styles.reviewIcon}
                                    src={parser(
                                      footerInfoData.companyAwards
                                        .birdEyeReviews.iframeUrl
                                    )}
                                    id="bfpublish"
                                    scrolling="no"
                                    style={{
                                      borderWidth: "0px",
                                      display: "block",
                                      overflow: "hidden",

                                      height: "75px",
                                    }}
                                  />
                                </a>
                                <p
                                  style={{ textAlign: "center" }}
                                  className={styles.birdeye}
                                >
                                  Powered by{" "}
                                  <a
                                    href={
                                      footerInfoData.companyAwards
                                        .birdEyeReviews.poweredByUrl
                                    }
                                    target="_blank"
                                    rel="noopener"
                                  >
                                    Birdeye
                                  </a>
                                </p>
                              </Img>
                            </Suspense>
                          </div>
                        </Col>
                        <Col
                          lg={2}
                          xl={2}
                          md={2}
                          sm={6}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                          }}
                        >
                          <div className="cellLogoDiv">
                            <a
                              href={
                                footerInfoData.companyAwards
                                  .equalOpportunityEmployer.url
                              }
                              target="_blank"
                            >
                              <img
                                className={styles.cellLogoImg}
                                src={
                                  footerInfoData.companyAwards
                                    .equalOpportunityEmployer.imgPath
                                }
                                style={{
                                  maxWidth: "100%",
                                  width: "100px",
                                  marginTop: "20px",
                                  height: "70px",
                                }}
                                title={
                                  footerInfoData.companyAwards
                                    .equalOpportunityEmployer.title
                                }
                                alt={
                                  footerInfoData.companyAwards
                                    .equalOpportunityEmployer.alt
                                }
                                loading="lazy"
                              />
                            </a>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>

            <Container className={styles.footer_link_banner}>
              <Row className={styles.footcont}>
                <Col
                  xl={4}
                  sm={12}
                  className={styles.padleft0 + " " + styles.copyrighttxt}
                >
                  <p className={styles.ul_footer + " " + styles.footer_list}>
                    © {currentYear} Sun West Mortgage Company, Inc. All Rights
                    Reserved
                  </p>
                </Col>
                <Col
                  xl={8}
                  sm={12}
                  md={12}
                  className={
                    styles.padleft0 +
                    " " +
                    styles.padright0 +
                    " " +
                    styles.dislinks
                  }
                >
                  <ul
                    className={
                      styles.ul_footer +
                      " " +
                      styles.footer_list +
                      " " +
                      styles.linklist
                    }
                  >
                    {footerInfoData.footerLinks.map((footerLinksData, j) =>
                      // Check if the name is "Ask Angel Ai" and skip rendering it
                      footerLinksData.name === "Ask Angel Ai" ? null : (
                        <li key={j}>
                          <a
                            href={footerLinksData.url}
                            style={{ color: "#fff" }}
                            title={footerLinksData.title}
                            target="_blank"
                          >
                            {footerLinksData.name}
                          </a>
                        </li>
                      )
                    )}
                  </ul>
                </Col>
              </Row>
            </Container>
          </>
        ) : (
          ""
        )}
      </footer>
    </FooterWrapper>
  );
};

export default CustomFooter;
